import moment from "moment";
import {
  dayValues,
  paymentStatusEnum,
  getEmptyCustomer,
  initialServiceWithDefaultData
} from "../state/initialState";
import {
  convertDurationScreenFormat2Api,
  convertDurationApi2ScreenFormat,
  convertApiUtcToLocalMoment,
  calculateTotalAppointmentDuration,
  convertTimeFromApi,
  convertDateTimeFromApi,
  toApiDateTime,
  toSpecificApiDateTime
} from "./helpers";
import objectAssign from "object-assign";
import { clone } from "../reducers/helper";

let payload = {};

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function isNotNullFalseOrEmpty(value) {
  if (
    value != "" &&
    JSON.stringify(value) != "[]" &&
    JSON.stringify(value) != "{}" &&
    value != null
  )
    return true;
  else return false;
}

export function convertAppointmentToApiModel(
  appointmentData,
  advancedAppointmentStepData,
  status,
  applyto,
  isMultiServiceAppointment,
  gotValidOffer,
  oldStartTime = null,
  locationId
) {
  let {
    selectedStaff,
    selectedService,
    selectedDate,
    selectedTime
  } = appointmentData.multiServiceList[0];

  payload = {};
  if (status) {
    payload.status = status;
  }
  if (applyto) {
    payload.applyto = applyto;
  }
  if (Number(selectedStaff.id) > 0) {
    payload.resourceid = selectedStaff.id + "";
  }
  if (Number(selectedService.id) > 0) {
    payload.serviceid = selectedService.id;
    payload.revenue = selectedService.price;
  } else {
    payload.serviceid = null;
    if (selectedService.price) {
      payload.revenue = selectedService.price;
    }
  }
  payload.starttime = toApiDateTime(
    selectedDate,
    selectedTime.stringValue,
    appointmentData.timeList
  );

  if (oldStartTime) {
    payload.splitfrom = oldStartTime;
  }

  if (
    (appointmentData.selectedCustomer.id ||
      appointmentData.selectedCustomer.firstname)
  ) {
    //payload.customerid = appointmentData.selectedCustomer.id; //we dont pass customer id, we always create a new customer per appointment
    payload.firstname = appointmentData.selectedCustomer.firstname;
    payload.lastname = appointmentData.selectedCustomer.lastname;
    payload.email = appointmentData.selectedCustomer.email;

    if (appointmentData.selectedCustomer.phone) {
      payload.phone = appointmentData.selectedCustomer.phone.replace(/ /g, "");
    } else {
      //DES-723
      payload.phone = "";
    }
  } else if (
    appointmentData.customerNameOrPhonenumberSearchQuery &&
    appointmentData.customerNameOrPhonenumberSearchQuery != ""
  ) {
    if (
      appointmentData.customerNameOrPhonenumberSearchQuery.trim().split(" ")
        .length > 1
    ) {
      payload.firstname = appointmentData.customerNameOrPhonenumberSearchQuery
        .trim()
        .split(" ")[0];
      payload.lastname = appointmentData.customerNameOrPhonenumberSearchQuery
        .trim()
        .split(" ")[1];
    } else {
      payload.firstname = appointmentData.customerNameOrPhonenumberSearchQuery;
      payload.lastname = "";
    }
    payload.email = "";
    payload.phone = "";
  }
  if (appointmentData.appointmentNotes) {
    payload.spmemo = appointmentData.appointmentNotes;
  } else if (
    appointmentData.appointmentNotes != undefined &&
    appointmentData.appointmentNotes != null &&
    appointmentData.appointmentNotes == ""
  ) {
    payload.spmemo = null;
  }

  if (!status && !isEmpty(appointmentData.selectedAppointmentStatus)) {
    payload.status =
      appointmentData.selectedAppointmentStatus.id ||
      appointmentData.selectedAppointmentStatus;
  }
  payload.address = appointmentData.address;

  payload.locationid = advancedAppointmentStepData.selectedLocationId || "";
  appointmentData = recurringAppointmentTransformation(
    appointmentData,
    advancedAppointmentStepData,
    applyto,
    isMultiServiceAppointment,
    gotValidOffer
  );
  return payload;
}

function recurringAppointmentTransformation(
  appointmentData,
  advancedAppointmentStepData = {},
  applyto,
  isMultiServiceAppointment,
  gotValidOffer
) {
  let { appointmentDuration } = appointmentData.multiServiceList[0];
  let {
    splitAppointmentFreeTime,
    splitAppointmentFinishTime,
    splitAppointmentBufferTime
  } = advancedAppointmentStepData.multiServiceAdvancedList[0];
  let {
    validOfferPurchasedId,
    bookingCameFromDbWithOffer
  } = advancedAppointmentStepData;

  if (validOfferPurchasedId && gotValidOffer && !bookingCameFromDbWithOffer)
    payload.offerpurchaseid = validOfferPurchasedId;

  let convertedDuration = convertDurationScreenFormat2Api(appointmentDuration);
  payload.duration = !convertedDuration ? "PT30M" : convertedDuration;
  if (splitAppointmentFreeTime !== "") {
    let convertedFreeTime = convertDurationScreenFormat2Api(
      splitAppointmentFreeTime
    );
    payload.availableduration =
      convertedFreeTime === null ? "PT00M" : convertedFreeTime;
  }
  if (!splitAppointmentFreeTime) {
    payload.availableduration = "PT00M";
  }
  if (splitAppointmentFinishTime !== "") {
    let convertedFinishTime = convertDurationScreenFormat2Api(
      splitAppointmentFinishTime
    );
    payload.secondduration =
      convertedFinishTime === null ? "PT00M" : convertedFinishTime;
  }
  if (!splitAppointmentFinishTime) {
    payload.secondduration = "PT00M";
  }
  if (splitAppointmentBufferTime !== "") {
    let convertedBufferTime = convertDurationScreenFormat2Api(
      splitAppointmentBufferTime
    );
    payload.bufferpostduration =
      convertedBufferTime === null ? "PT00M" : convertedBufferTime;
  }
  if (!splitAppointmentBufferTime) {
    payload.bufferpostduration = "PT00M";
  }

  // Recurring Appointment
  let _inclusiondates = [];
  payload.recurrence =
    appointmentData.paymentStatus == paymentStatusEnum.STATUS_UNKNOWN
      ? {}
      : null;
  if (
    !advancedAppointmentStepData.recurringToggleOn &&
    appointmentData.paymentStatus == paymentStatusEnum.STATUS_UNKNOWN &&
    applyto == "thisandfuture"
  ) {
    payload.recurrence.frequency = "N";
    payload.applyto = "thisandfuture";
  } else if (!advancedAppointmentStepData.recurringToggleOn) {
    delete payload.recurrence;
    // do nothing
  } else if (advancedAppointmentStepData.selectedRepeatOption.id === "D") {
    // ---------------- DAILY ---------------
    payload.recurrence.frequency =
      advancedAppointmentStepData.selectedRepeatOption.id;
    payload.recurrence.interval =
      advancedAppointmentStepData.selectedEveryDayOption.value;
    if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "numberOfTimes"
    ) {
      payload.recurrence.endtype = "count";
      payload.recurrence.count =
        advancedAppointmentStepData.selectedTimeNumberOption.value;
    } else if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "untilDate"
    ) {
      let dateApiFormat =
        moment(
          moment(
            advancedAppointmentStepData.selectedEndDate,
            "YYYY-MM-DDTHH:mm"
          )._d
        ).format("YYYYMMDD") + "L";
      payload.recurrence.endtype = "until";
      payload.recurrence.until = dateApiFormat;
    }

    if (advancedAppointmentStepData.recurringToggleOn) {
      advancedAppointmentStepData.recurringOnTimeSelectedList.map(i => {
        _inclusiondates.push(i.split("^")[1]);
      });
    }
  } else if (advancedAppointmentStepData.selectedRepeatOption.id === "W") {
    // --------------- WEEKLY --------------
    //payload.recurrence = {};
    payload.recurrence.frequency =
      advancedAppointmentStepData.selectedRepeatOption.id;
    payload.recurrence.interval =
      advancedAppointmentStepData.selectedEveryWeekOption.value;

    let weekdays = [];
    let { selectedRepeatOnOptionsSelected } = advancedAppointmentStepData;

    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Mon) > -1) {
      weekdays.push("mo");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Tue) > -1) {
      weekdays.push("tu");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Wed) > -1) {
      weekdays.push("we");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Thu) > -1) {
      weekdays.push("th");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Fri) > -1) {
      weekdays.push("fr");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Sat) > -1) {
      weekdays.push("sa");
    }
    if (selectedRepeatOnOptionsSelected.indexOf(dayValues.Sun) > -1) {
      weekdays.push("su");
    }

    payload.recurrence.weekdays = weekdays;

    if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "numberOfTimes"
    ) {
      payload.recurrence.endtype = "count";
      payload.recurrence.count =
        advancedAppointmentStepData.selectedTimeNumberOption.value;
    } else if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "untilDate"
    ) {
      let dateApiFormat =
        moment(
          moment(
            advancedAppointmentStepData.selectedEndDate,
            "YYYY-MM-DDTHH:mm"
          )._d
        ).format("YYYYMMDD") + "L";
      payload.recurrence.endtype = "until";
      payload.recurrence.until = dateApiFormat;
    }

    if (advancedAppointmentStepData.recurringToggleOn) {
      advancedAppointmentStepData.recurringOnTimeSelectedList.map(i => {
        _inclusiondates.push(i.split("^")[1]);
      });
    }
  } else if (advancedAppointmentStepData.selectedRepeatOption.id === "M") {
    // MONTHLY
    //payload.recurrence = {};
    payload.recurrence.frequency =
      advancedAppointmentStepData.selectedRepeatOption.id;
    payload.recurrence.interval =
      advancedAppointmentStepData.selectedEveryMonthOption.value;

    if (
      advancedAppointmentStepData.selectedRepeatOnMonthOptionSelected ==
      "dayofweek"
    ) {
      payload.recurrence.monthtype = "dayofweek";
    } else {
      payload.recurrence.monthtype = "dayofmonth";
    }

    if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "numberOfTimes"
    ) {
      payload.recurrence.endtype = "count";
      payload.recurrence.count =
        advancedAppointmentStepData.selectedTimeNumberOption.value;
    } else if (
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption ==
      "untilDate"
    ) {
      let dateApiFormat =
        moment(
          moment(
            advancedAppointmentStepData.selectedEndDate,
            "YYYY-MM-DDTHH:mm"
          )._d
        ).format("YYYYMMDD") + "L";
      payload.recurrence.endtype = "until";
      payload.recurrence.until = dateApiFormat;
    }

    if (advancedAppointmentStepData.recurringToggleOn) {
      advancedAppointmentStepData.recurringOnTimeSelectedList.map(i => {
        _inclusiondates.push(i.split("^")[1]);
      });
    }
  } else if (advancedAppointmentStepData.selectedRepeatOption.id === "S") {
    // SPECIFIC
    payload.recurrence.frequency =
      advancedAppointmentStepData.selectedRepeatOption.id;
    advancedAppointmentStepData.recurringOnTimeSelectedList.map(i => {
      _inclusiondates.push(i.split("^")[1]);
    });
  }
  //payload.recurrence.frequency = appointmentData.RecurringAppointment.repeat;
  if (
    _inclusiondates.length > 0 &&
    advancedAppointmentStepData.recurringToggleOn
  ) {
    payload.recurrence.inclusiondates = _inclusiondates;
  }

  if (advancedAppointmentStepData.recurringToggleOn) {
    // DES-774
    let excludedDates = advancedAppointmentStepData.futureAppointmentClashes;
    let modifiedDates = advancedAppointmentStepData.futureAppointmentClashesResolved.filter(
      x => !(x || {}).excluded
    );
    let doubleBookedDates = advancedAppointmentStepData.futureAppointmentClashesResolved.filter(
      x => (x || {}).doublebooked
    );

    if (appointmentData.doubleBookingEnabled) {
      // TODO: Need to test if this is needed while save or save and edit also.
      payload.doublebookingdates = [payload.starttime];
      if (doubleBookedDates && doubleBookedDates.length > 0) {
        payload.doublebookingdates = payload.doublebookingdates.concat(
          doubleBookedDates.map(clashItem => {
            return toApiDateTime(
              clashItem.startDateAndTime,
              clashItem.startTime.stringValue,
              advancedAppointmentStepData.timeListForClashes
            );
          }) || []
        );

        excludedDates = excludedDates.filter(
          y =>
            !doubleBookedDates.find(
              z => z.startDateAndTime == y.startDateAndTime
            )
        );
      }
    }

    payload.recurrence.exclusiondates = (
      advancedAppointmentStepData.existingExclussions || []
    ).concat(
      excludedDates.map(clashItem => {
        return toSpecificApiDateTime(
          clashItem.startDateAndTime
        );
      })
    );

    if (payload.recurrence.exclusiondates.length == 0) {
      delete payload.recurrence.exclusiondates;
    }

    payload.recurrence.inclusiondates = _inclusiondates.concat(
      modifiedDates.map(clashItem => {
        return toApiDateTime(
          clashItem.startDateAndTime,
          clashItem.startTime.stringValue,
          advancedAppointmentStepData.timeListForClashes
        );
      }) || []
    );
  }

  if (
    !payload.recurrence ||
    isMultiServiceAppointment ||
    validOfferPurchasedId
  ) {
    delete payload.recurrence;
  }

  //EXCLUSION DATES FOR CONFLICTING APPOINTMENTS :

  // if(appointmentData.RecurringAppointment.specific.exclusiondates && appointmentData.RecurringAppointment.specific.exclusiondates.length > 0
  //     && advancedAppointmentStepData.selectedRepeatOption.id !== "S") {
  //         if(appointmentData.RecurringAppointment.isRecurring) {
  //             payload.recurrence.exclusiondates = appointmentData.RecurringAppointment.specific.exclusiondates;
  //         }
  // }
}

let getRepeatList = () => {
  let {
    Daily,
    Weekly,
    Monthly,
    Specific
  } = window.APP.LANGUAGE.Pages.AppointmentAdvanced;
  return [
    { name: Daily, id: "D" },
    { name: Weekly, id: "W" },
    { name: Monthly, id: "M" },
    { name: Specific, id: "S" }
  ];
};

export function convertAppointmentFromApiModel(
  bookingToTranslate,
  currentAppointmentStepData,
  currentAdvancedAppointmentStepData,
  timezone,
  isSibbling = false,
  isUpdate = false
) {
  let {
    selectedTime,
    selectedDate,
    loadedBookingForResourceWithinDates
  } = currentAppointmentStepData.multiServiceList[0];
  let { timeList } = currentAppointmentStepData;

  if (bookingToTranslate.booking) {
    bookingToTranslate = bookingToTranslate.booking;
  }
  let selectedService = {};

  let selectedCustomer = getEmptyCustomer();

  let selectedStaff = {};
  let staffNoPreference = false;
  let customerNameOrPhonenumberSearchQuery = "";
  if (bookingToTranslate.customerid) {
    selectedCustomer.id = bookingToTranslate.customerid;
    if (bookingToTranslate.firstname)
      selectedCustomer.firstname = bookingToTranslate.firstname;
    if (bookingToTranslate.lastname)
      selectedCustomer.lastname = bookingToTranslate.lastname;
    if (bookingToTranslate.email)
      selectedCustomer.email = bookingToTranslate.email;
    if (bookingToTranslate.phone)
      selectedCustomer.phone = bookingToTranslate.phone;
  } else {
    if (bookingToTranslate.firstname)
      customerNameOrPhonenumberSearchQuery = bookingToTranslate.firstname;
    if (bookingToTranslate.lastname)
      customerNameOrPhonenumberSearchQuery += " " + bookingToTranslate.lastname;
  }

  if (bookingToTranslate.serviceid) {
    selectedService = clone(
      currentAppointmentStepData.serviceList.find(
        x => x.id == bookingToTranslate.serviceid
      ) || { id: bookingToTranslate.serviceid }
    ); //clone so we dont update the service off the list
  }

  if (bookingToTranslate.price) {
    selectedService.price = bookingToTranslate.price;
    selectedService.defaultPrice = bookingToTranslate.price;
  } //DES-727

  if (bookingToTranslate.revenue) {
    selectedService.price = bookingToTranslate.revenue;
  }

  if (bookingToTranslate.resourceid) {
    selectedStaff = currentAppointmentStepData.staffList.find(
      x => x.id == bookingToTranslate.resourceid
    ) || { id: bookingToTranslate.resourceid };
  }

  if (
    bookingToTranslate.staffnopreference &&
    bookingToTranslate.type === "onlinebooking"
  ) {
    staffNoPreference = bookingToTranslate.staffnopreference;
  }

  //recursive conversion

  let selectedRepeatOption = {};
  let selectedEveryDayOption = {};
  let selectedTimeNumberOption = {};
  let selectedEveryWeekOption = {};
  let selectedRepeatOnOptionsSelected = [];
  let recurringOnTimeSelectedList = [];
  let selectedEveryMonthOption = {};
  let advancedAppointmentStepData = {};
  if (
    bookingToTranslate.recurrence &&
    bookingToTranslate.recurrence.frequency == "N" &&
    bookingToTranslate.applyto == "thisandfuture"
  ) {
    advancedAppointmentStepData.recurringToggleOn = false;
  } else if (
    bookingToTranslate.recurrence &&
    bookingToTranslate.recurrence.frequency === "D"
  ) {
    // ---------------- DAILY ---------------
    advancedAppointmentStepData.recurringToggleOn = true;
    selectedRepeatOption.id = bookingToTranslate.recurrence.frequency;

    if (selectedRepeatOption) {
      selectedRepeatOption = getRepeatList().find(
        x => x.id == selectedRepeatOption.id
      );
    }

    selectedEveryDayOption.value = bookingToTranslate.recurrence.interval;

    if (bookingToTranslate.recurrence.endtype == "count") {
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "numberOfTimes";
      selectedTimeNumberOption.value = bookingToTranslate.recurrence.count;
    } else if (bookingToTranslate.recurrence.endtype == "until") {
      //translate data from api
      let MM = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(4, 6);
      let DD = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(6, 8);
      let YYYY = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(0, 4);
      advancedAppointmentStepData.selectedEndDate = moment(
        MM + "-" + DD + "-" + YYYY,
        "MM-DD-YYYY"
      );
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "untilDate";
    }

    if (bookingToTranslate.recurrence.inclusiondates) {
      bookingToTranslate.recurrence.inclusiondates.map(bookingTime => {
        let localTime = convertApiUtcToLocalMoment(bookingTime, timezone);
        let screenFormat =
          localTime.format("MMM DD, YYYY") + "|" + localTime.format("HH:mm");
        let apiFormat = bookingTime;
        recurringOnTimeSelectedList.push(screenFormat + "^" + apiFormat);
      });
    }
  } else if (
    bookingToTranslate.recurrence &&
    bookingToTranslate.recurrence.frequency === "W"
  ) {
    // --------------- WEEKLY --------------
    advancedAppointmentStepData.recurringToggleOn = true;
    selectedRepeatOption.id = bookingToTranslate.recurrence.frequency;
    selectedEveryWeekOption.value = bookingToTranslate.recurrence.interval;

    if (bookingToTranslate.recurrence.weekdays) {
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "mo")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Mon);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "tu")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Tue);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "we")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Wed);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "th")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Thu);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "fr")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Fri);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "sa")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Sat);
      }
      if (bookingToTranslate.recurrence.weekdays.find(x => x.day == "su")) {
        selectedRepeatOnOptionsSelected.push(dayValues.Sun);
      }
    }

    if (bookingToTranslate.recurrence.endtype == "count") {
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "numberOfTimes";
      selectedTimeNumberOption.value = bookingToTranslate.recurrence.count;
    } else if (bookingToTranslate.recurrence.endtype == "until") {
      let MM = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(4, 6);
      let DD = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(6, 8);
      let YYYY = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(0, 4);
      advancedAppointmentStepData.selectedEndDate = moment(
        MM + "-" + DD + "-" + YYYY,
        "MM-DD-YYYY"
      );

      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "untilDate";
    }
    if (bookingToTranslate.recurrence.inclusiondates) {
      bookingToTranslate.recurrence.inclusiondates.map(bookingTime => {
        let localTime = convertApiUtcToLocalMoment(bookingTime, timezone);
        let screenFormat =
          localTime.format("MMM DD, YYYY") + "|" + localTime.format("HH:mm");
        let apiFormat = bookingTime;
        recurringOnTimeSelectedList.push(screenFormat + "^" + apiFormat);
      });
    }
  } else if (
    bookingToTranslate.recurrence &&
    bookingToTranslate.recurrence.frequency === "M"
  ) {
    // MONTHLY
    advancedAppointmentStepData.recurringToggleOn = true;
    selectedRepeatOption.id = bookingToTranslate.recurrence.frequency;
    selectedEveryMonthOption.value = bookingToTranslate.recurrence.interval;

    if (bookingToTranslate.recurrence.monthtype == "dayofweek") {
      advancedAppointmentStepData.selectedRepeatOnMonthOptionSelected =
        bookingToTranslate.recurrence.monthtype;
    } else {
      advancedAppointmentStepData.selectedRepeatOnMonthOptionSelected =
        bookingToTranslate.recurrence.monthtype;
    }

    if (bookingToTranslate.recurrence.endtype == "count") {
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "numberOfTimes";
      selectedTimeNumberOption.value = bookingToTranslate.recurrence.count;
    } else if (bookingToTranslate.recurrence.endtype == "until") {
      let MM = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(4, 6);
      let DD = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(6, 8);
      let YYYY = bookingToTranslate.recurrence.until
        .split("L")[0]
        .substring(0, 4);
      advancedAppointmentStepData.selectedEndDate = moment(
        MM + "-" + DD + "-" + YYYY,
        "MM-DD-YYYY"
      );
      advancedAppointmentStepData.selectedRecurringEndOfPeriodRadioOption =
        "untilDate";
    }

    if (bookingToTranslate.recurrence.inclusiondates) {
      bookingToTranslate.recurrence.inclusiondates.map(bookingTime => {
        let localTime = convertApiUtcToLocalMoment(bookingTime, timezone);
        let screenFormat =
          localTime.format("MMM DD, YYYY") + "|" + localTime.format("HH:mm");
        let apiFormat = bookingTime;
        recurringOnTimeSelectedList.push(screenFormat + "^" + apiFormat);
      });
    }
  } else if (
    bookingToTranslate.recurrence &&
    bookingToTranslate.recurrence.frequency === "S"
  ) {
    // SPECIFIC
    advancedAppointmentStepData.recurringToggleOn = true;
    selectedRepeatOption.id = bookingToTranslate.recurrence.frequency;

    if (bookingToTranslate.recurrence.inclusiondates) {
      bookingToTranslate.recurrence.inclusiondates.map(bookingTime => {
        let localTime = convertApiUtcToLocalMoment(bookingTime, timezone);
        let screenFormat =
          localTime.format("MMM DD, YYYY") + "|" + localTime.format("HH:mm");
        let apiFormat = bookingTime;
        recurringOnTimeSelectedList.push(screenFormat + "^" + apiFormat);
      });
    }
  }
  // recurring logic

  bookingToTranslate.starttime = convertApiUtcToLocalMoment(
    bookingToTranslate.starttime,
    timezone
  );
  bookingToTranslate.endtime = convertApiUtcToLocalMoment(
    bookingToTranslate.endtime,
    timezone
  );

  let newSelectedDate = convertDateTimeFromApi(bookingToTranslate.starttime);
  let newSelectedTime = convertTimeFromApi(bookingToTranslate.starttime);
  let thisIsRecurringAppointmentAndFirstInListSoIgnoreApi = false;
  if (
    bookingToTranslate.bookingtimes &&
    bookingToTranslate.bookingtimes.length > 0 &&
    selectedTime &&
    selectedTime.value &&
    !bookingToTranslate.multisvc
  ) {
    thisIsRecurringAppointmentAndFirstInListSoIgnoreApi = true;
  }

  advancedAppointmentStepData.selectedRepeatOption = isNotNullFalseOrEmpty(
    selectedRepeatOption
  )
    ? selectedRepeatOption
    : currentAdvancedAppointmentStepData.selectedRepeatOption;
  advancedAppointmentStepData.selectedEveryDayOption = isNotNullFalseOrEmpty(
    selectedEveryDayOption
  )
    ? selectedEveryDayOption
    : currentAdvancedAppointmentStepData.selectedEveryDayOption;
  advancedAppointmentStepData.selectedTimeNumberOption = isNotNullFalseOrEmpty(
    selectedTimeNumberOption
  )
    ? selectedTimeNumberOption
    : currentAdvancedAppointmentStepData.selectedTimeNumberOption;
  advancedAppointmentStepData.selectedEveryWeekOption = isNotNullFalseOrEmpty(
    selectedEveryWeekOption
  )
    ? selectedEveryWeekOption
    : currentAdvancedAppointmentStepData.selectedEveryWeekOption;
  advancedAppointmentStepData.selectedRepeatOnOptionsSelected = isNotNullFalseOrEmpty(
    selectedRepeatOnOptionsSelected
  )
    ? selectedRepeatOnOptionsSelected
    : currentAdvancedAppointmentStepData.selectedRepeatOnOptionsSelected;
  advancedAppointmentStepData.recurringOnTimeSelectedList = isNotNullFalseOrEmpty(
    recurringOnTimeSelectedList
  )
    ? recurringOnTimeSelectedList
    : currentAdvancedAppointmentStepData.recurringOnTimeSelectedList;
  advancedAppointmentStepData.selectedEveryMonthOption = isNotNullFalseOrEmpty(
    selectedEveryMonthOption
  )
    ? selectedEveryMonthOption
    : currentAdvancedAppointmentStepData.selectedEveryMonthOption;

  delete bookingToTranslate.address.id;
  delete bookingToTranslate.address.countrycode;
  delete bookingToTranslate.address.address2;

  bookingToTranslate.address.address1 =
    bookingToTranslate.address.address1 || "";
  bookingToTranslate.address.city = bookingToTranslate.address.city || "";
  bookingToTranslate.address.postalcode =
    bookingToTranslate.address.postalcode || "";
  bookingToTranslate.address.state = bookingToTranslate.address.state || "";
  if (bookingToTranslate.customerid) {
    selectedCustomer.address = bookingToTranslate.address || {};
  }

  let firstMultiItem = objectAssign(initialServiceWithDefaultData(), {
    appointmentDuration: convertDurationApi2ScreenFormat(
      bookingToTranslate.duration
    ),
    selectedStaff: selectedStaff,
    staffNoPreference: staffNoPreference,
    selectedService: selectedService,
    indexAmongstSibblings: bookingToTranslate.multisvcindex || 0,
    serviceSearchQuery: "",
    originalTimeOfFirstAppointmentInRecurringSeries: convertTimeFromApi(
      bookingToTranslate.starttime
    ),
    originalDateOfFirstAppointmentInRecurringSeries: convertDateTimeFromApi(
      bookingToTranslate.starttime
    ),
    selectedDate: thisIsRecurringAppointmentAndFirstInListSoIgnoreApi
      ? selectedDate
      : convertDateTimeFromApi(bookingToTranslate.starttime),
    selectedTime: thisIsRecurringAppointmentAndFirstInListSoIgnoreApi
      ? selectedTime
      : convertTimeFromApi(bookingToTranslate.starttime),
    bookingId: bookingToTranslate.id,
    loadedBookingForResourceWithinDates: loadedBookingForResourceWithinDates,
    appointmentEndTimeFromApi: convertTimeFromApi(bookingToTranslate.endtime),
    originalDurationOfFirstAppointmentInRecurringSeries: convertDurationApi2ScreenFormat(
      bookingToTranslate.duration
    ),
    sibblingStatus: bookingToTranslate.status.id
  });

  let firstMultiAdvancedItem = {
    bookingId: bookingToTranslate.id,
    splitAppointmentFreeTime: convertDurationApi2ScreenFormat(
      bookingToTranslate.availableduration
    ),
    splitAppointmentFinishTime: convertDurationApi2ScreenFormat(
      bookingToTranslate.secondduration
    ),
    splitAppointmentBufferTime: convertDurationApi2ScreenFormat(
      bookingToTranslate.bufferpostduration
    )
  };

  let multiServiceList = [firstMultiItem];

  let sibblingBookingIds = [];

  if (bookingToTranslate.multisvcbookings) {
    bookingToTranslate.multisvcbookings.forEach((o, i) => {
      sibblingBookingIds.push({
        id: o.id
      });
    });
  }

  advancedAppointmentStepData.multiServiceAdvancedList = [
    firstMultiAdvancedItem
  ];

  advancedAppointmentStepData.validOfferPurchasedId =
    bookingToTranslate.offerpurchaseid || "";
  advancedAppointmentStepData.offerId =
    bookingToTranslate.offerconfirmationidentifier || "";
  if (bookingToTranslate.offerconfirmationidentifier) {
    advancedAppointmentStepData.bookingCameFromDbWithOffer = true;
  }

  advancedAppointmentStepData.existingExclussions =
    (bookingToTranslate.recurrence || {}).exclusiondates || [];

  if (
    bookingToTranslate &&
    bookingToTranslate.status &&
    bookingToTranslate.status.description == "New."
  ) {
    bookingToTranslate.status.id = 3;
  }

  return {
    currentBookingId: bookingToTranslate.id,
    bookingChannel: bookingToTranslate.bookingchannel || "",
    confirmationIdentifier: bookingToTranslate.confirmationidentifier,
    sibblingBookingIds: sibblingBookingIds,
    gotValidOffer: !!bookingToTranslate.offerpurchaseid,

    isMultiServiceAppointment: bookingToTranslate.multisvc || false,
    sibblingBookingsTotalStartingFromZero:
      bookingToTranslate.multisvctotal || 0,
    appointmentStepData: {
      timeSlotsContainingAppointments:
        currentAppointmentStepData.timeSlotsContainingAppointments,
      unavailableTimeList: currentAppointmentStepData.unavailableTimeList,
      bookingObtainedFromDbWithCustomer: !!selectedCustomer.id,
      invoiceKey: bookingToTranslate.invoicekey,
      bookingTimesUsedForRecurring: bookingToTranslate.bookingtimes,
      appType: bookingToTranslate.type,
      appUsage: bookingToTranslate.appusage,
      selectedAppointmentStatus: {
        id: bookingToTranslate.status.id
      },
      clientSpecialRequestComments: bookingToTranslate.specialrequest || "",
      multiServiceList: multiServiceList,
      address: bookingToTranslate.address || {},
      appointmentNotes: bookingToTranslate.spmemo || "",
      selectedCustomer: selectedCustomer,
      customerNameOrPhonenumberSearchQuery: customerNameOrPhonenumberSearchQuery
    },
    advancedAppointmentStepData: advancedAppointmentStepData,
    checkoutAppointmentStepData: {
      invoiceKey: bookingToTranslate.invoicekey,
      bookingRevenue: bookingToTranslate.revenue,
      shouldUpdateInvoiceToBooking: true
    },
    isSibblingsMissingInUpdate: isUpdate
  };
}

export function checkRecurringClashesForDoubleBooking(
  payload,
  response,
  appointmentData
) {
  if (
    response &&
    response.clashes &&
    response.clashes.length > 0 &&
    appointmentData.doubleBookingEnabled &&
    payload.doublebookingdates &&
    payload.doublebookingdates.length > 0
  ) {
    const doubleBookingIndex = payload.doublebookingdates.indexOf(
      payload.starttime
    );
    if (doubleBookingIndex > -1) {
      response.clashes = response.clashes.filter(
        x => x.localstart !== payload.starttime
      );
    }
  }
  return response;
}
